module.exports = __webpack_public_path__ + "img/mouth-02.737659d4.svg";